import { Injectable, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormSubmissionService } from './form-submission.service';
import { FormDataService } from './form-data.service';
import { JornayaService } from './jornaya.service';
import { Session } from 'inspector';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root'
})
export class LandingApiProgressService implements OnInit {


  environment: any = {
    apiBaseUrl: "https://landinghelper.azurewebsites.net/api",
    apiToken: "79148e5b-5a49-49b2-8eb1-1eebcec31730"
  };  

  private jornayaGateStarted = false;
  private jornayaGateOpen = false;
  private jornayaGateOpenedAt = 0;
  private jornayaGateTimer: number | null = null;
  private jornayaGateMaxWaitMs = 10000;
  private latestJornayaToken = '';
  private pendingProgressQueue: any[] = [];
  private readonly pendingProgressMaxSize = 120;

  constructor(
    private http: HttpClient,
    private formSubmissionService: FormSubmissionService,
    private formDataService: FormDataService,
    private window: WindowService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  private get storage(): Storage | null {
    return this.window.window?.localStorage ?? null;
  }

  ngOnInit(): void {
    
  }

  prepareSave(step: any, currentStep: number): any {
      if (!this.isBrowser) return;

      this.ensureJornayaGateStarted();

      var params: { [key: string]: string } = {};
      const userAgent = this.window.navigatorUserAgent;

      if(this.window && this.window.locationSearch) {
          const _params = new URLSearchParams(this.window.locationSearch);
          _params.forEach((value, key) => {
          params[key] = value;
        });        
      }

      const formData = this.formDataService.getCurrentFormData();

      const lead = this.formSubmissionService.prepareLeadData(formData, "");    

      var BrowserName = this.getOS() + " " + this.getBrowserName();      
      var CurrentDeviceType = "Desktop";
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
        CurrentDeviceType = "Mobile";
      }

      var utmSourceParts = params['utm_source'] ? params['utm_source'].split('_') : [];
      var OfferID = 0;
      var ThreadID = 0;
      if(utmSourceParts.length > 1) {
        OfferID = parseInt(utmSourceParts[1], 10);
        ThreadID = parseInt(utmSourceParts[2], 10);
      }

      var jsonstr = JSON.stringify(lead);
      console.log(lead)
      
      var requestData = {
          DropDate: params['utm_term'] || "",
          Phone: lead.Phone || parseInt(params['confirmation'], 10) || 0,
          StepName: step?.key || "",
          StepID: currentStep,          
          RecordID:  parseInt(params['RecordID'], 10) || 0,
          DateAdde: new Date(),
          VerticalType: lead.VerticalID,
          OfferID: OfferID || 0,
          ThreadID: ThreadID || 0,
          jsonValue: jsonstr,
          RecordsForSMSReservedID: parseInt(params['RecordsForSMSReservedAutoID'], 10) || 0,
          BrowserName: BrowserName,
          DeviceType: CurrentDeviceType,
          //UserAgent: navigator.userAgent, //JLFranco
          UserAgent: this.window.navigatorUserAgent,
          JornayaToken: lead.JornayaToken || null,
          //SessionID: localStorage.getItem('Session-Guid') //JLFranco
          SessionID: this.storage?.getItem('Session-Guid') ?? null ,
          OfferURLID: parseInt(params['OfferURLID'], 10) || 0,
      };

      if (!requestData.JornayaToken && this.latestJornayaToken) {
        requestData.JornayaToken = this.latestJornayaToken;
      }

      if (requestData.JornayaToken) {
        this.latestJornayaToken = requestData.JornayaToken;
        if (!this.jornayaGateOpen) {
          this.openJornayaGateAndFlush('token-ready');
        }
      }

      if (!this.jornayaGateOpen) {
        this.enqueuePendingProgress(requestData);
        this.logJornayaDebug('progress:queued', {
          queueSize: this.pendingProgressQueue.length,
          stepName: requestData.StepName || '',
          stepId: requestData.StepID,
          tokenLen: (requestData.JornayaToken || '').length,
          tokenMasked: this.maskJornayaToken(requestData.JornayaToken || ''),
        });
        return;
      }

      this.logJornayaDebug('progress:save-immediate', {
        stepName: requestData.StepName || '',
        stepId: requestData.StepID,
        tokenLen: (requestData.JornayaToken || '').length,
        tokenMasked: this.maskJornayaToken(requestData.JornayaToken || ''),
      });

      this.save(requestData);

  }

  //#region Jornaya Gate Management 

  onJornayaTokenReady(token: string): void {
    if (!token || !this.isBrowser) {
      return;
    }

    this.latestJornayaToken = token;
    this.logJornayaDebug('progress:token-ready', {
      tokenLen: token.length,
      tokenMasked: this.maskJornayaToken(token),
      queueSize: this.pendingProgressQueue.length,
    });
    if (!this.jornayaGateOpen) {
      this.openJornayaGateAndFlush('token-ready');
    }
  }

  /**
   * 2026-08-03
   * Contexto:
   * El paso progress temprano puede correr antes de que el token de Jornaya se haya poblado en el input oculto. 
   * Observamos progress guardado con token vacío seguidos de la disponibilidad del token unos segundos después.
   *
   * Decision:
   * - Mantener el progreso no bloqueante para la experiencia del usuario (UX).
   * - Almacenar en memoria los eventos de progreso iniciales.
   * - Vaciar tan pronto como el token esté disponible, o después de un tiempo de espera máximo (10s), lo que ocurra primero.
   */
  private ensureJornayaGateStarted(): void {
    if (this.jornayaGateStarted || !this.window.window) {
      return;
    }

    this.jornayaGateStarted = true;
    this.jornayaGateOpenedAt = Date.now();
    this.logJornayaDebug('progress:gate-started', {
      maxWaitMs: this.jornayaGateMaxWaitMs,
    });
    this.jornayaGateTimer = this.window.window.setTimeout(() => {
      this.openJornayaGateAndFlush('timeout');
    }, this.jornayaGateMaxWaitMs);
  }

  private enqueuePendingProgress(requestData: any): void {
    if (this.pendingProgressQueue.length >= this.pendingProgressMaxSize) {
      this.pendingProgressQueue.shift();
    }

    this.pendingProgressQueue.push(requestData);
  }

  private openJornayaGateAndFlush(reason: 'token-ready' | 'timeout'): void {
    if (this.jornayaGateOpen || !this.isBrowser) {
      return;
    }

    this.jornayaGateOpen = true;
    this.logJornayaDebug('progress:gate-opened', {
      reason,
      queueSize: this.pendingProgressQueue.length,
      waitedMs: Date.now() - this.jornayaGateOpenedAt,
      latestTokenLen: this.latestJornayaToken.length,
      latestTokenMasked: this.maskJornayaToken(this.latestJornayaToken),
    });
    if (this.jornayaGateTimer !== null && this.window.window) {
      this.window.window.clearTimeout(this.jornayaGateTimer);
      this.jornayaGateTimer = null;
    }

    while (this.pendingProgressQueue.length > 0) {
      const requestData = this.pendingProgressQueue.shift();
      if (requestData && !requestData.JornayaToken && this.latestJornayaToken) {
        requestData.JornayaToken = this.latestJornayaToken;
      }
      this.logJornayaDebug('progress:flushed-item', {
        stepName: requestData?.StepName || '',
        stepId: requestData?.StepID,
        tokenLen: (requestData?.JornayaToken || '').length,
        tokenMasked: this.maskJornayaToken(requestData?.JornayaToken || ''),
      });
      this.save(requestData);
    }
  }

  private isDebugJornayaEnabled(): boolean {
    const search = this.window.locationSearch;
    if (!search) return false;
    const value = new URLSearchParams(search).get('debugJornaya')?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.isDebugJornayaEnabled()) {
      return;
    }
    console.log(`[JORNAYA-DEBUG][landing-api-progress] stage=${stage}`, details);
  }

  private maskJornayaToken(token: string): string {
    if (!token) {
      return '';
    }

    const normalized = token.trim();
    if (normalized.length <= 8) {
      return `${normalized.slice(0, 2)}...${normalized.slice(-2)}`;
    }

    return `${normalized.slice(0, 6)}-...-${normalized.slice(-2)}`;
  }

  //#endregion Jornaya Gate Management 


  async save(requestData: any): Promise<void> {
    try {
      const headers = this.getRequestHeaders();
      const saveLeadURL = this.getSaveLandingApiProgressUrl();
      
      const response = await this.http.post(saveLeadURL, requestData, { headers }).toPromise();

    } catch (error) {
      console.error('Submission error:', error);
    } finally {
    }
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'withCredentials': 'true',
      'Authorization': 'true',
      'Token': this.environment.apiToken
    });
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private getSaveLandingApiProgressUrl(): string {
    return `${this.environment.apiBaseUrl}/SaveLandingApiProgress`;
  }
  
  private getBrowserName(): string {
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName  = navigator.appName;
      var fullVersion  = ''+parseFloat(navigator.appVersion); 
      var majorVersion = parseInt(navigator.appVersion,10);
      var nameOffset,verOffset,ix,verOffset2;

      // In Opera, the true version is after "OPR" or after "Version"
      if ((verOffset=nAgt.indexOf("OPR"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In MS Edge, the true version is after "Edg" in userAgent
      else if ((verOffset=nAgt.indexOf("Edg"))!=-1) {
        browserName = "Microsoft Edge";
        fullVersion = nAgt.substring(verOffset+4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
          
          if(verOffset2=nAgt.indexOf("CriOS") !=-1)
          {
              browserName = "Chrome";
              fullVersion = nAgt.substring(verOffset+7);
              if ((verOffset2=nAgt.indexOf("Version"))!=-1) 
                  fullVersion = nAgt.substring(verOffset2+8);
          }
          else
          {
              browserName = "Safari";
              fullVersion = nAgt.substring(verOffset+7);
              if ((verOffset=nAgt.indexOf("Version"))!=-1) 
                  fullVersion = nAgt.substring(verOffset+8);
          }

      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset+8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < 
                (verOffset=nAgt.lastIndexOf('/')) ) 
      {
        browserName = nAgt.substring(nameOffset,verOffset);
        fullVersion = nAgt.substring(verOffset+1);
        if (browserName.toLowerCase()==browserName.toUpperCase()) {
        browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix=fullVersion.indexOf(";"))!=-1)
          fullVersion=fullVersion.substring(0,ix);
      if ((ix=fullVersion.indexOf(" "))!=-1)
          fullVersion=fullVersion.substring(0,ix);

      majorVersion = parseInt(''+fullVersion,10);
      if (isNaN(majorVersion)) {
        fullVersion  = ''+parseFloat(navigator.appVersion); 
        majorVersion = parseInt(navigator.appVersion,10);
      }

      return browserName;
  }

  private getOS() {
    const userAgent = this.window.navigatorUserAgent,
        platform = this.window.navigatorUserPlatform,
        macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (/Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }



}
